import { MenuDto } from "src/types/base";
import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { UserResponseDto } from "../dtos/user/response/userResponseDto";
import { UserSimpleResponseDto } from "../dtos/user/response/userSimpleResponseDto";
import { getData, patchData } from "../utils/axios/serverHelper";
import { BookmarkCdList } from "src/store/useCommonCodeStore";
import { encryptPassword } from "../utils/auth/passwordEncrypt";
import { hasLoginRecorded, markLoginRecorded } from "../utils/auth/authConfig";

const baseUrl = `${config.apiUrl}/user`;

export const getUserBySearch = async (keyword: string) => {
    const url = `${baseUrl}`

    return await getData<ResponseDto<UserSimpleResponseDto[]>>(url, {
        params: { keyword }
    });
}

export const getUserDetail = async (empNo: string) => {
    const url = `${baseUrl}/info`
    return await getData<ResponseDto<UserSimpleResponseDto>>(url, {
        params: { empNo }
    });
}

export const getMyInfo = async () => {
    const url = `${baseUrl}/me`;

    const isNewSession = !hasLoginRecorded();

    const response = await getData<ResponseDto<UserResponseDto>>(url, {
        headers: isNewSession ? { 'X-New-Session': 'true' } : undefined,
    });

    if (isNewSession && response?.data?.successFlag) {
        markLoginRecorded();
    }

    return response;
}

//파라미터 없이 요청만 보내기
export const getBookmarkList = async () => {
    const url = `${baseUrl}/bookMark`;
    return await getData<ResponseDto<BookmarkCdList[]>>(url);
}

export const userBookmark = async (bookMark: string) => {
	const url = `${baseUrl}/bookMark`;

	return await patchData<Partial<UserResponseDto>, ResponseDto<UserResponseDto>>(url, {
			bookMark : bookMark
		}
	);
}

export const changeMyPassword = async (currentPassword: string, newPassword: string) => {
	const url = `${baseUrl}/password`;

	return await patchData<{ currentPassword: string; newPassword: string }, ResponseDto<any>>(url, {
		currentPassword: encryptPassword(currentPassword),
		newPassword: encryptPassword(newPassword)
	});
}